import styled from 'styled-components';
import media from '../../../../../../styles/Media.styled';
import { astriskStyle } from 'src/styles/CommonStyles.styled';
import {  FONT_FAMILY_REGULAR, SECONDARY_FONT_COLOR,SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';

export const Title = styled.div`
    font-family:${FONT_FAMILY_REGULAR};
    color: ${SECONDARY_FONT_COLOR};
    font-size: ${SMALL_TEXT_PX};
    margin-bottom: 8px;

    ${astriskStyle};
`;

export const ProcedureDropdownContainer = styled.div`
    opacity: 1;
    width: 350px;
    margin: ${({ isPhysician }) => (isPhysician ? '0 0 0 auto' : '0 0 0 35px')};
    ${media.smalDevice`
        height: 74px;
        width:100%;
    `}
    ${media.mobileDevice`
        height: 74px;
    `}
     ${media.mobileDevice`
       margin-bottom:  ${({ marginBottom }) => marginBottom && marginBottom};
    margin:   ${({ isPhysician }) => (isPhysician ? '0 0 0 auto' : '0 0 0 0')};

    `}
     @media only screen and (min-width: 768px) and (max-width: 770px) {
        width: 350px;
        margin: 0 0 0 0;
    }
    @media only screen and (min-width: 1023px) and (max-width: 1025px) {
        margin: 0 0 0 10px;
    }

    @media only screen and (min-width: 820px) and (max-width: 823px) {
        margin: 0 0 0 10px;
    }
`;
export const ProcedureContainer = styled.div`
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    ${media.smalDevice`
        margin-bottom: 0px;
    `}
`;
